import React, { useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/marlea/Navbar";
import { Hero } from "@/components/marlea/Hero";
import { PainSection } from "@/components/marlea/PainSection";
import { SolutionSection } from "@/components/marlea/SolutionSection";
import { WhatItDoes } from "@/components/marlea/WhatItDoes";
import { WhyNow } from "@/components/marlea/WhyNow";
import { ForWho } from "@/components/marlea/ForWho";
import { HowItWorks } from "@/components/marlea/HowItWorks";
import { DemoForm } from "@/components/marlea/DemoForm";
import { FAQ } from "@/components/marlea/FAQ";
import { FinalCta } from "@/components/marlea/FinalCta";
import { Footer } from "@/components/marlea/Footer";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Landing = () => {
  const scrollDemo = useCallback(() => scrollToId("demo"), []);
  const scrollHow = useCallback(() => scrollToId("hoe-werkt-het"), []);

  return (
    <div className="min-h-screen bg-[#0A0A1A] text-white">
      <Navbar onScrollDemo={scrollDemo} />
      <main>
        <Hero onScrollDemo={scrollDemo} onScrollHow={scrollHow} />
        <PainSection />
        <SolutionSection />
        <WhatItDoes />
        <WhyNow />
        <ForWho />
        <HowItWorks />
        <DemoForm />
        <FAQ />
        <FinalCta onScrollDemo={scrollDemo} />
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(22,28,46,0.95)",
            border: "1px solid rgba(0,239,255,0.25)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
